import React, { FC } from 'react'
import { Icon, IconSize, type IconType, CopyText } from '@awell-health/design-system'

interface InfoFieldProps {
  icon: IconType
  label: string | React.ReactNode
  value: string
  isCopyable?: boolean
}

export const InfoField: FC<InfoFieldProps> = ({ icon, label, value, isCopyable }) => (
  <div className="flex items-start gap-2">
    <Icon icon={icon} size={IconSize.s} className="mt-1 text-slate-400" />
    <div>
      {typeof label === 'string' ? <p className="text-sm font-medium">{label}</p> : label}
      {isCopyable ? (
        <CopyText text={value}>
          <p className="text-sm text-slate-600 break-all">{value}</p>
        </CopyText>
      ) : (
        <p className="text-sm text-slate-600">{value}</p>
      )}
    </div>
  </div>
)
